import * as types from '../mutation-types'
import userService from '../api/services/users'
const state = {
  main: {},
  notificate: [],
  persons: [],
  getfile: [],
  Permission: [],
  rules: [],
  roles: [],
  budgetProject: [],
  budget: [],
  empAll: [],
  empConfig: { "menuPin": false, "bookRowsPerPage": 10, "tscRowsPerPage": 5, "prRowsPerPage": 10 },
  linestatus: false
}

const getters = {
  empCode(state) {
    if (state.main.empCode) {
      return state.main.empCode
    }
    return ''
  },
  empConfig(state) {
    return state.empConfig
  },
  rules(state) {
    return state.main.Rule
  },
  roles(state) {
    return state.main.Role
  },
  budgetProject(state) {
    return state.budgetProject
  },
  budget(state) {
    return state.budget
  },
  empMy(state) {
    return state.empMy
  },
  checkPermission: (state) => (value) => {
    if (value && value instanceof Array && value.length > 0) {
      const roles = state.main.Role
      if (!roles) {
        return false
      }
      const permissionRoles = value

      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role)
      })

      if (!hasPermission) {
        return false
      }
      return true
    } else {
      // console.error(`need roles! Like v-permission="['admin','editor']"`)
      // ไม่เป็น Array ให้แสดงไว้ก่อน
      return true
    }
  },
  isAuthen(state) {
    // if (state.main.success === undefined) {
    //   if (localStorage.getItem('tai_user') !== null) {
    //     state.main = JSON.parse(localStorage.getItem('tai_user'))
    //   } else {
    //     return false
    //   }
    // }
    return !!state.main.success
  },
  token(state) {
    // if (state.main.token === undefined) {
    //   if (localStorage.getItem('tai_user') !== null) {
    //     state.main = JSON.parse(localStorage.getItem('tai_user'))
    //   } else {
    //     return ''
    //   }
    // }
    return state.main.token
  },
  lineStatus(state) {
    return state.linestatus.status
  },
  prListCount(state) {
    if (!state.prListCount) {
      return {}
    }
    if (!state.prListCount.data) {
      return {}
    }
    if (state.prListCount.data.length > 0) {
      return state.prListCount.data[0]
    } else {
      return {}
    }
  }
}

const mutations = {
  [types.USER_AUTHEN](state, userAuth) {
    state.main = userAuth
    // localStorage.setItem('tai_user', JSON.stringify(userAuth))
  },
  [types.USER_LINESTATUS](state, linestatus) {
    state.linestatus = linestatus
  },
  [types.USER_PRLISTCOUNT](state, prListCount) {
    state.prListCount = prListCount
  },
  USER_BUDGET(state, budget) {
    state.budget = budget
  },
  USER_BUDGETPROJECT(state, budgetProject) {
    state.budgetProject = budgetProject
  },
  USER_GETALL(state, empAll) {
    state.empAll = empAll
    localStorage.setItem('EmpAll', JSON.stringify(empAll))
    state.empMy = empAll.filter((e) => {
      if (e.EmpCode === state.main.empCode) return e
    })
  },
  // USER_AUTHEN (state, userAuth) {
  //   state.main = userAuth
  //   // localStorage.setItem('tai_user', JSON.stringify(userAuth))
  // },
  setNotificate(state, payload) {
    state.notificate = payload
    console.log('setNotificate', state)
  },
  setPersons(state, payload) {
    state.persons = payload
  },
  setDep(state, payload) {
    state.dep = payload
  },
  setgetFile(state, payload) {
    state.getfile = payload
  },
  setPermission(state, payload) {
    state.Permission = payload
  },
  setRole(state, payload) {
    state.main.Role = payload
    // state.roles = payload
  },
  setEmpConfig(state, payload) {
    state.empConfig = payload
  }
}

const actions = {
  signIn: ({ state, commit, dispatch }, playload) => {
    // API request
    return userService
      .signin(playload)
      .then(response => {
        if (response) {
          console.log('actions signin', response.data)
          commit(types.USER_AUTHEN, response.data)
          dispatch('getEmpAll')
          dispatch('getEmpConfig')
          dispatch('checkLineStatus')
          dispatch('prListCount')
          // dispatch('budgetProjectCode')
          // dispatch('budgetCode')


        } else {
          state.main = { success: false }
          state.notificate = []
          console.error('signin server error')
        }
      })
      .catch(error => {
        state.main = { success: false }
        state.notificate = []
        console.error(error)
      })
  },
  signOut: ({ state }) => {
    console.log('signOut', state.main)
    // localStorage.setItem('tai_user', '{}')
    localStorage.removeItem('vuex')
    state.main = {}
    state.notificate = []
  },
  prListCount({ state, commit }) {
    let data
    if (state.main) {
      data = { emp: state.main.empCode }
    } else {
      data = { emp: '0000' }
    }
    return userService.prListCount(data)
      .then(res => {
        commit(types.USER_PRLISTCOUNT, res)
        console.log('prListCount then', res)
        // state.linestatus = res
        // let temp_pr = { "App": "PR", "ID": 1, "EmpCode": state.main.empCode, "Title": "ใบขอสั่งซื้อรอกลั่นกรอง", "Link": "pr/prdochdList/default%20appv2" }
        // state.notificate.push(temp_pr)
        return state.prListCount
      })
      .catch(err => {
        console.log('prListCount err', err)
        state.prListCount = []
        return state.prListCount
      })
  },
  checkLineStatus({ state, commit }) {
    let data = { emp: state.main.empCode }
    return userService.linestatus(data)
      .then(res => {
        commit(types.USER_LINESTATUS, res)
        console.log('status line then', res)
        // state.linestatus = res
        return state.linestatus
      })
      .catch(err => {
        console.log('status line err', err)
        state.linestatus.status = false
        return state.linestatus
      })
  },
  budgetProjectCode({ state, commit }) {
    let data = { EmpCode: state.main.empCode }
    return userService.budgetProject(data)
      .then(res => {
        commit('USER_BUDGETPROJECT', res.data)
        console.log('USER_BUDGETPROJECT res.data', res.data)
        // state.linestatus = res
        return res.data.data
      })
      .catch(err => {
        console.log('USER_BUDGETPROJECT err', err)
        console.error(err)
      })
  },
  budgetCode({ state, commit }) {
    let data = { EmpCode: state.main.empCode }
    return userService.budget(data)
      .then(res => {
        commit('USER_BUDGET', res.data)
        console.log('USER_BUDGET res.data', res.data)
        // state.linestatus = res
        return res.data.data
      })
      .catch(err => {
        console.log('USER_BUDGET err', err)
        console.error(err)
      })
  },
  budgetCodeByParam({ commit }, payload) {
    let data = payload
    return userService.budget(data)
      .then(res => {
        commit('USER_BUDGET', res.data)
        console.log('USER_BUDGET res.data', res.data)
        // state.linestatus = res
        return res.data.data
      })
      .catch(err => {
        console.log('USER_BUDGET err', err)
        console.error(err)
      })
  },
  getEmpAll({ state, commit }) {
    let data = {}
    return userService.getEmp(data)
      .then(res => {
        localStorage.setItem('EmpAll', '')
        commit('USER_GETALL', res.data.data)
        console.log('USER_GETALL res.data', res.data)
        // state.linestatus = res
        return res.data.data
      })
      .catch(err => {
        console.log('USER_BUDGET err', err)
        state.linestatus.status = false
        return []
      })
  },
  getEmpConfig({ state, commit }) {
    let payload = { EmpCode: state.main.empCode }
    return userService.empConfig(payload)
      .then(res => {
        let data = res.data.data[0]
        if (data.EmpConfig) {
          data = JSON.parse(data.EmpConfig)
        }
        commit('setEmpConfig', data)
        return res
      })
      .catch(err => {
        return err
      })
  },
  lineNotify({ state }, playload) {
    return userService.linenotify(playload)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  emailNotify({ state }, playload) {
    return userService.linenotify(playload)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  lineOTP({ state }, playload) {
    return userService.lineotp(playload)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  emailOTP({ state }, playload) {
    return userService.emailotp(playload)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  lineOTPCheck({ state }, playload) {
    return userService.lineotpcheck(playload)
      .then(res => {
        return res
      })
      .catch(err => {
        return err
      })
  },
  changeRole({ commit }, playload) {
    commit('setRole', playload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}

// const mutations = {
//   [types.FETCH_USER] (state, users) {
//     state.main = users
//   },
//   setloginUser (state, loginUser) {
//     state.main.loginuser = loginUser.data
//     localStorage.setItem('taiuser', JSON.stringify(loginUser.data))
//   }
// }